export const moveUserToDay = (dateToMove?: string) => {
  const sidebarAndContentContainer = document.querySelector('.records.table');
  const [currentDate] = new Date().toISOString().split('T');
  const currentDayFirstCell = document.querySelector(
    `.day.date-${dateToMove || currentDate}`
  );
  const leftOffset = (currentDayFirstCell as HTMLElement)?.offsetLeft;

  sidebarAndContentContainer?.scrollTo({
    left: leftOffset,
    behavior: 'instant',
  });
};
